
export interface AgentRequest {
    conversation_id: string;
    question: string;
    chain_id: number;
}

export interface AgentResponseContract {
    transaction_id: string;
    status: AgentStatus;
    answer: string;
    frontend_options: FrontendOptions;
    turn_id: string;
    user_rating: -1 | 0 | 1;
}

export interface AgentResponse {
    transactionId: string;
    turnId: string;
    status: AgentStatus;
    answer: string;
    options: FrontendOptions;
    userRating: -1 | 0 | 1;
}

export enum AgentStatus {
    Pending = 'pending',
    Completed = 'completed',
    Error = 'error',
}

export interface FrontendOptions {
    periods: FrontendPeriodOption[];
    hotels: FrontendHotelOption[];
}

export interface FrontendPeriodOption {
    id: string;
    start: string;
    end: string;
}

export interface FrontendHotelOption {
    id: number;
    code: string;
    name: string;
}
